import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  Spinner,
} from "@fluentui/react-components";
import { ArrowSyncCheckmarkRegular } from "@fluentui/react-icons";
import { toast } from "components/FluentToast";
import { VSpace } from "components/Spacer";
import React from "react";
import { useTranslation } from "react-i18next";
import { useAppStoreState } from "store/AppStore";
import { useInsurerReportsStore } from "store/InsurerReportsStore";

export const MatchInsurerReportDialog = () => {
  const [
    { matchInsurerReportDialog, matchInsurerReportStatus },
    {
      setInsurerReportsStoreValue,
      setInsurerReportsStoreValues,
      matchInsurerReport,
      applyInsurerReport,
    },
  ] = useInsurerReportsStore();
  const { taxonomy, grecoCompanies } = useAppStoreState();

  const isLoading = matchInsurerReportStatus === "loading";
  const { t } = useTranslation();

  return (
    <Dialog open={matchInsurerReportDialog.isOpen}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>{t("pct.rematchInsurerReport.label")}</DialogTitle>
          <DialogContent>
            {t("pct.rematchInsurerReportConfirm.label")}
            <VSpace height={20} />
          </DialogContent>
          <DialogActions>
            <Button
              appearance="secondary"
              disabled={isLoading}
              onClick={() => {
                setInsurerReportsStoreValue("matchInsurerReportDialog", {
                  isOpen: false,
                  insurerReportId: null,
                });
              }}
            >
              {t("pct.close.label")}
            </Button>
            <Button
              data-help="insurer-reports-rematch-confirm"
              appearance="primary"
              disabled={isLoading}
              icon={
                isLoading ? (
                  <Spinner size="tiny" />
                ) : (
                  <ArrowSyncCheckmarkRegular fontSize={16} />
                )
              }
              onClick={() => {
                matchInsurerReport(
                  {
                    insurerReportId: matchInsurerReportDialog.insurerReportId,
                  },
                  (matchedInsurerReport) => {
                    setInsurerReportsStoreValues({
                      matchInsurerReportDialog: {
                        isOpen: false,
                        insurerReportId: null,
                      },
                    });
                    toast.success(t("greco.success"));
                    // the endpoint returns the rematched report with all of its
                    // entries, so the page is patched instead of reloaded
                    applyInsurerReport({
                      insurerReport: matchedInsurerReport,
                      taxonomy,
                      grecoCompanies,
                      t,
                    });
                  }
                );
              }}
            >
              {t("pct.rematch.label")}
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
